// extracted by mini-css-extract-plugin
export default {"InputHeader":"InputHeader_InputHeader__qKeZT","InputHeader_input":"InputHeader_InputHeader_input__sibKX","InputHeader_back":"InputHeader_InputHeader_back__pXJth"};